export const siteName = '美女与野兽';

export const siteSlogan = '发现好故事 · 影视资源展示与推荐平台';

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '关于我们', to: '/about' },
];

export const siteStats = [
  { value: '12,800+', label: '收录影视作品' },
  { value: '3,400+', label: '演员资料库' },
  { value: '每日更新', label: '上映与热播资讯' },
  { value: '4.8 / 5', label: '用户喜爱度' },
];

export const footerColumns = [
  {
    title: '内容导航',
    links: [
      { label: '首页', to: '/' },
      { label: '电影分类', to: '/category/movie' },
      { label: '电视剧分类', to: '/category/tv' },
      { label: '影视搜索', to: '/search' },
    ],
  },
  {
    title: '热门类型',
    links: [
      { label: '科幻', to: '/category/movie?genre=科幻' },
      { label: '悬疑', to: '/category/movie?genre=悬疑' },
      { label: '爱情', to: '/category/tv?genre=爱情' },
      { label: '犯罪', to: '/category/tv?genre=犯罪' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '内容更新说明', to: '/about' },
      { label: '联系我们', to: '/about' },
    ],
  },
];

export const friendLinks = ['国家电影资料馆', '影迷社区', '剧集观察', '独立影评人联盟', '数字放映厅'];